import React, { useEffect } from 'react'
import styles from "./workDetail.module.css";
import { WorkDetailSec } from '../../components';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useSelect } from '@react-three/drei';
import { fetchOurWorkDetailData } from '../../slice/workSlice';


const WorkDetail = () => {

    const { workId } = useParams();
     const dispatch = useDispatch();
     const {data : workData, loading, error } = useSelector((state) => state.work);

     useEffect(() => {
        dispatch(fetchOurWorkDetailData(workId));
     },[workId, dispatch]);

     useEffect(() => {
        console.log(" workId", workId);
    },[workData]);

    useEffect(() => {
        console.log(" Our Work Detail Data  : ", workData);
    },[workData]);


    return (
        <div className={styles.WorkDetail}>
            <WorkDetailSec workData = {workData} workDetails={workData.workDetails}/>
        </div>
    )
}

export default WorkDetail
